export default function fixDate (iso){
    const d = new Date(iso);
    const date = d.toLocaleDateString("en-EN", {
        year: "numeric",
        month: "long",
        day: "2-digit"
    });

    const time = d.toLocaleTimeString("en-EN", {
        hour: "2-digit",
        minute: "2-digit"
    });

    return `${date} • ${time}`;
};
